import { faChevronLeft, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import logo from "../../../../../assets/images/logo.png";
import { useRecoilValue } from "recoil";
import { gameProposalIdState } from "src/recoil/atoms/gameProposalState";

const Main = styled.main`
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  
`;

const ContentBox = styled.div`
  width: 500px;
  text-align: left;
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
`;

const Image = styled.img`
  width: 150px;
  margin-bottom: 20px;
  padding-right: 30px;
`;

const Title = styled.h2`
  color: #2282e9;
  font-size: 18px;
  margin-bottom: 12px;
`;

const Description = styled.p`
  color: #666;
  font-size: 14px;
  font-weight: 600;
  line-height: 2.5;
  margin: 0;
`;



export default function FinishAddTest() {
  const location = useLocation();
  const title = location.state?.title;
  return (
    <Main>
        <Image src="/images/finish-test-add.svg" alt="캐릭터" />
      <ContentBox>
        
        <Title>{title} 게임 테스트 제출이 완료되었습니다.</Title>
        <Description>
          심사는 영업일 기준 <span style={{color: "#2282E9"}}>1-2일 정도 소요</span>됩니다. <br />

          심사가 완료된 후 {`[테스트 목록]`} - {`[게임 테스트 상세]`} - {`[테스트 시작하기]`}
          <br />
          버튼을 통해 게임 테스트를 진행하실 수 있습니다.
        </Description>
      </ContentBox>
    </Main>
  );
}
